export default __webpack_public_path__ + "static/media/notfound.bccb473a.png";